var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatureicon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.38 17.7502H10.38M8.38001 4.75024V8.75024M5.38001 2.75024V10.7502M2.38 5.75024V7.75024M11.38 5.75024V7.75024M4.38 13.7502C4.382 17.9022 4.428 20.0252 5.698 21.3622C7.016 22.7502 9.138 22.7502 13.38 22.7502H13.83C17.637 22.7502 19.54 22.7502 20.803 21.6152C20.9823 21.4539 21.1487 21.2786 21.302 21.0892C22.38 19.7602 22.38 17.7572 22.38 13.7502C22.38 9.74324 22.38 7.73824 21.302 6.41024C21.1495 6.22202 20.9823 6.04614 20.802 5.88424C19.7 4.89024 18.106 4.76624 15.18 4.75024H14.38",
    stroke: "#1776EE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6958 15.9082L8.59058 15.9082",
    stroke: "#1776EE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6958 14.0134L8.59058 14.0134",
    stroke: "#1776EE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6958 12.1187L8.59058 12.1187",
    stroke: "#1776EE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureicon4);
export default __webpack_public_path__ + "static/media/featureicon_4.4ac2ca1ac935a773284fac9cf62b18d9.svg";
export { ForwardRef as ReactComponent };